module.exports = __webpack_public_path__ + "images/psp/militarySizeGuide/unit-10x20.svg";